import React from "react";
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from "../../../components/table/TableOps";
import {
  Dialog,
  DialogContentText,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Snackbar,
  Slide,
} from "@material-ui/core";
import Http from "../../../Http";
import PreguiaLog from "../../../components/PreguiaLog";
import Confirmacion from "../confirmaciones/Confirmacion";
import Recepcion from "../recepcion/Recepcion";
import Asignar from "../pendientes/Asignar";
import Autorizar from "./Autorizar";
import Pdf from '../../../components/pdfViewer'
import ACCESS from "../../../ACCESS";

class Preguias extends TableComponent {
  componentDidMount() {
    const acciones = [
      {
        id: "asignar",
        icon: "directions_bus",
        tooltip: "Asignar Transportista",
        access: [ACCESS.PREGUIA.ASIGNAR_A_TRASNPORTISTA]
      },
      { id: "confirmar", icon: "check", tooltip: "Confirmar Recolección", access: [ACCESS.PREGUIA.CONFIRMAR_RECOLECCION] },
      {
        id: "sucursal",
        icon: "assignment",
        tooltip: "Confirmar Entrada Sucursal",
        access: [ACCESS.PREGUIA.CONFIRMAR_ENTRADA_EN_SUSURSAL]
      },
      { id: "historial", icon: "history", tooltip: "Historial", access: [ACCESS.PREGUIA.VER_HISTORIAL_DE_LA_PREGUIA] },
      { id: "cancel", icon: "cancel", tooltip: "Cancelar", access: [ACCESS.PREGUIA.CANCELAR_PREGUIAS_CREADAS_POR_EL_USUARIO,
        ACCESS.PREGUIA.CANCELAR_PREGUIAS_DE_SUCURSAL_DEL_USUARIO, ACCESS.PREGUIA.CANCELAR_TODAS_PREGUIAS
      ] },
      { id: "edit", icon: "edit", tooltip: "Editar Preguia", access: [ACCESS.PREGUIA.EDITAR_PREGUIAS_CREADAS_POR_EL_USUARIO,
        ACCESS.PREGUIA.EDITAR_PREGUIAS_SUCURSAL_DEL_USUARIO, ACCESS.PREGUIA.EDITAR_TODAS_PREGUIAS
      ] },
      { id: "auth", icon: "lock", tooltip: "Autorizar Preguia", access: [ACCESS.PREGUIA.AUTORIZAR_PREGUIA] },
      { id: "detalles", icon: "listalt", tooltip: "Cambiar Detalles de Carga", access: [ACCESS.PREGUIA.CAMBIAR_DETALLES_DE_CARGA] },
      { id: 'carta_porte', icon: 'notifications', tooltip: 'Carta Porte', access: [ACCESS.PREGUIA.CARTA_PORTE_PREGUIA] },
      { id: 'show', icon: "visibility", tooltip: "Ver Preguia", access: [ACCESS.PREGUIA.CARTA_PORTE_PREGUIA] },
    ];

    this.tableConfig(
      {
        dataUrl: "preguia/filter",
        deleteUrl: "sucursal/delete",
        deleteField: "sucursal_nombre",
        modUrl: "/Preguias/Preguia",
      },
      TableOp.Table(
        false,
        [
          { label: "Recolección", id: "id" },
          { label: "Estado", id: "preguia_estado" },
          { label: "Sucursal", id: "sucursal" },
          { label: "Solicitante", id: "pg_receptor" },
          { label: "Fecha Solicitud", id: "createdAt" },
          { label: "Fecha Recoleccion", id: "pg_pro_fecha" },
          { label: "Fecha Recolectada", id: "pg_recol_fecha" },
          { label: "Cliente", id: "cliente" },
          { label: "Transportista", id: "transportista" },
          { label: "Folio Guia", id: "g_folio" },
          { label: "Usuario", id: "usuario" },
        ],
        acciones
      )
    );
    this.table();
    this.loadTransportistas();
    this.setState({
      acciones: {
        cancel: {
          title: "Cancelar",
          content: `Se va a cancelar la preguía. ¿Esta Seguro?`,
          onCancel: () => this.cancel(false),
          onOk: () => this.cancel(true),
        },
        historial: {
          title: "Historial de la preguía",
          Component: PreguiaLog,
          onCancel: null,
          onOk: null,
        },
        asignar: {
          title: "Asignar chofer",
          content: "",
          Component: Asignar,
          onCancel: null,
          onOk: null,
        },
        confirmar: {
          title: "Confirmar Recoleccion",
          content: "",
          Component: Confirmacion,
          onCancel: null,
          onOk: null,
          fullScreen: true,
        },
        sucursal: {
          title: "Confirmar Entrada Sucursal",
          content: "",
          Component: Recepcion,
          onCancel: null,
          onOk: null,
        },
        auth: {
          title: "Autorizar Preguia",
          content: "",
          Component: Autorizar,
          onCancel: null,
          onOk: null,
        },
        detalles: {
          title: "Cambiar Detalles de Carga",
          content: "",
          Component: Confirmacion,
          onCancel: null,
          onOk: null,
          fullScreen: true,
        },
      },
    });
  }

  loadTransportistas = async () => {
    // let TRes = await Http.get("unidad-transporte/all");
    // let camiones = await Http.get("camion/all");
    //if (!TRes.error && !camiones.error) {
      this.setState({ transportistas: [], camiones: [] });
    //}
  };

  action = (id, row) => {
    let { sbMsg, sbOpen, dRow, dOpen, currentAction, id_unidad_transporte } =
      this.state;
    if (id === "cancel") {
      if (row.pg_estado !== 1) {
        sbMsg = "La recolección no puede ser cancelada";
        sbOpen = true;
      } else {
        dRow = row;
        dOpen = true;
        currentAction = id;
        sbOpen = false;
        sbMsg = "";
      }
    } else if (id === "historial") {
      dRow = row;
      dOpen = true;
      currentAction = id;
      sbOpen = false;
      sbMsg = "";
    } else if (id === "asignar") {
      if (row.pg_estado > 1) {
        sbMsg = "La recolección ya fue asignada";
        sbOpen = true;
      } else if (row.pg_estado === 1) {
        dRow = row;
        dOpen = true;
        currentAction = id;
        sbOpen = false;
        sbMsg = "";
        id_unidad_transporte = row.id_unidad_transporte;
      }
    } else if (id === "confirmar") {
      if (row.pg_estado > 3) {
        sbMsg = "La recolección ya fue confirmada";
        sbOpen = true;
      } else if (row.pg_estado < 3) {
        sbMsg = "La recolección no puede ser confirmada aún";
        sbOpen = true;
      } else if (row.pg_estado === 3) {
        dOpen = true;
        dRow = row;
        currentAction = id;
        sbOpen = false;
        sbMsg = "";
      }
    } else if (id === "sucursal") {
      if (row.pg_estado > 5) {
        sbMsg = "La recolección ya confirmo entrada en la sucursal";
        sbOpen = true;
      } else if (row.pg_estado < 5) {
        sbMsg = "La recolección no puede ser asignada a sucursal";
        sbOpen = true;
      } else if (row.pg_estado === 5) {
        dOpen = true;
        dRow = row;
        currentAction = id;
        sbOpen = false;
        sbMsg = "";
      }
    } else if (id === "edit") {
      /* if (sbOpen || row.pg_estado !== 1) {
        sbOpen = true;
        sbMsg =  'La recolección no puede ser editada'
      } else { */
      this.props.history.push(`/Preguias/Preguia/${row.id}`);
      // }
    } else if (["show", "show_sucursal", "show_self"].includes(id)) {
      /* if (sbOpen || row.pg_estado !== 1) {
        sbOpen = true;
        sbMsg =  'La recolección no puede ser editada'
      } else { */
      this.props.history.push(`/Preguias/Preguia/${row.id}`);
      // }
    } else if (id === "auth") {
      if (row.pg_estado !== 8) {
        sbMsg = "La recolección ya fue autorizada";
        sbOpen = true;
      } else {
        dOpen = true;
        dRow = row;
        currentAction = id;
        sbOpen = false;
        sbMsg = "";
      }
    } else if (id === "detalles") {
      if (row.pg_estado > 3) {
        sbMsg = "La recolección ya fue confirmada";
        sbOpen = true;
      } else {
        dOpen = true;
        dRow = row;
        currentAction = id;
        sbOpen = false;
        sbMsg = "";
      }
    } else if (id === "carta_porte") { 
      dRow = row;
      this.getCartaPorte(row);
    }
    if (row.pg_estado === 0) {
      sbMsg = "La recoleccion fue cancelada";
    }
    /* if (row.pg_estado === 8) {
      sbMsg = "La recolección no ha sido autorizada";
      sbOpen = true;
    }  */
    this.setState({
      sbMsg,
      sbOpen,
      dRow,
      dOpen,
      currentAction,
      id_unidad_transporte,
    });
  };

  cancel = async (op) => {
    this.setState({ loading: true });
    if (op) {
      try {
        let Res = await Http.post(`preguia/${this.state.dRow.id}/cancelar`, {});
        if (!Res.error) {
          this.table();
          this.setState({ dOpen: false, loading: false });
        }
      } catch (error) {}
      return;
    }
    this.setState({ dOpen: false, loading: false });
  };

  /** Acciones  Asignar transportista*/
  asignarTransportista = async () => {
    const { transportista, camion, dRow } = this.state;
    if (!transportista) return this.setState({ dOpen: false });
    if (!camion) return this.setState({ dOpen: false });
    let Res = await Http.post("preguia/save", {
      id: dRow.id,
      id_unidad_transporte: transportista,
      id_camion: camion,
      pg_estado: 3,
    });
    if (!Res.error) {
      this.setState({ dOpen: false });
      this.table();
    }
  };

  onTransportistaChange = (e) => {
    this.setState({ transportista: e.target.value });
  };

  onCamionChange = (e) => {
    this.setState({ camion: e.target.value });
  };

  getCartaPorte = async (row) => {
    this.setState({ loading: true });
    const Res = await Http.get(`preguia/carta-porte/${row.id}`);
    if (!Res.error) {
      this.setState({ loading: false, dOpen: false });
      await this.downloadPDFReport(row.id);
    } else {
      this.setState({
        loading: false,
        sbMsg: `preguia #${row.id} ${Res.errMsg}`,
        sbOpen: true,
      });
    }
  }

  /** Acciones Confirmar Recoleccion */
  onConfirmar = async (detalles) => {
    const { dRow, currentAction } = this.state;
    let pg_estado = 5;
    let recolectada = true;
    if (currentAction === "detalles") {
      pg_estado = undefined;
      recolectada = false;
    }
    const Res = await Http.post(`preguia/save-preguia`, {
      preguia: {
        ...detalles,
        ...detalles.cliente,
        id_cliente_main: detalles.cliente.id,
        id: dRow.id,
        pg_estado,
        recolectada,
      },
      detalles,
    });
    if (!Res.error) {
      this.setState({ loading: false, dOpen: false });
      if (Res.data.cartaporte) {
        await this.downloadPDFReport(dRow.id);
      } else {
        this.setState({
          loading: false,
          sbMsg: `Recoleccion Confirmada. Error al crear carta porte. 
          ${Res.data.cartaporte_error}`,
          sbOpen: true,
        });
      }
      this.table();
    } else {
      this.setState({
        loading: false,
        sbMsg: "Error al guardar",
        sbOpen: true,
      });
    }
  };

  /** Acciones Confirmar Recepcion en sucursal */
  onConfirmarSucursal = async (detalles) => {
    let { id_unidad_transporte, pg_destinos, pg_recep_fecha } = detalles;
    const { dRow } = this.state;
    pg_recep_fecha = pg_recep_fecha ? pg_recep_fecha : new Date();
    pg_destinos = pg_destinos ? pg_destinos : 1;
    if (!id_unidad_transporte) return this.setState({ tdOpen: false });
    let Res = await Http.post("preguia/recibida", {
      id: dRow.id,
      id_unidad_transporte,
      pg_destinos,
      pg_recep_fecha,
      pg_estado: 7,
      pg_destinos_rest: pg_destinos,
    });
    if (!Res.error) {
      this.setState({ dOpen: false });
      this.table();
    }
  };

  handleDialog = async (action) => {
    const { acciones, currentAction } = this.state;
    const Action = acciones && currentAction && acciones[currentAction];
    if (action && Action.onOk) {
      await Action.onOk();
    }
    this.setState({ dOpen: false, transportista: null }, () => {
      this.table();
    });
  };

  downloadPDFReport = async (id) => {
    const Resp = await Http.get(
      `carta-porte/pdf?iddocumento=${id}&tipo=1`,
      true,
      "arraybuffer"
    );
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: "application/pdf" });
      this.setState({
        pdfURL: URL.createObjectURL(blob),
        viewPdf: true,
      });
    }
  };

  handledownloadPdf = () => {
    const { pdfURL } = this.state;
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = pdfURL;
    a.download = `carta_porte.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(pdfURL);
  };

  handledownloaZip = async () => {
    const { dRow } = this.state;
    const Resp = await Http.get(
      `carta-porte/xml?iddocumento=${dRow.id}&tipo=1`,
      true,
      "arraybuffer"
    );
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: "application/xml" });
      const zipURL = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.style.display = "none";
      a.href = zipURL;
      a.download = `cartas_porte_${dRow.id}.xml`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(zipURL);
    }
  };

  viewPdfClose = () => {
    this.setState({ viewPdf: false });
  };

  render() {
    const {
      dOpen,
      dRow,
      acciones,
      currentAction,
      transportista,
      transportistas,
      camion,
      camiones,
      sbOpen,
      sbMsg,
      pdfURL,
      viewPdf = false,
    } = this.state;
    const { hasAccess } = this.context;
    const Action = acciones && currentAction && acciones[currentAction];
    return (
      <div>
        <div
          style={{
            display: "flex",
            padding: 10,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h1>Recolecciones</h1>
          {hasAccess(ACCESS.PREGUIA.CREAR_PREGUIA) && (
            <Button
              color="primary"
              variant={"contained"}
              onClick={() => {
                this.props.history.push(`/Preguias/Preguia`);
              }}
            >
              Nueva Recolección
            </Button>
          )}
        </div>
        <this.TableRender />

        {acciones && currentAction && (
          <Dialog
            fullScreen={Action.fullScreen}
            open={dOpen ? dOpen : false}
            onClose={() => this.handleDialog(false)}
            maxWidth={"xl"}
          >
            <DialogTitle>
              {Action.title || ""} Preguía #{dRow.id}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>{Action.content || ""}</DialogContentText>
              {Action.Component && (
                <Action.Component
                  accion={currentAction}
                  preguia={dRow}
                  id={dRow.id}
                  transportista={transportista}
                  transportistas={transportistas}
                  onTransportistaChange={this.onTransportistaChange}
                  camion={camion}
                  camiones={camiones}
                  onCamionChange={this.onCamionChange}
                  onConfirmar={this.onConfirmar}
                  onConfirmarSucursal={this.onConfirmarSucursal}
                  onClose={() => this.handleDialog(false)}
                />
              )}
            </DialogContent>
            {Action.onOk && (
              <DialogActions>
                <Button
                  onClick={() => this.handleDialog(false)}
                  color="primary"
                >
                  No
                </Button>
                <Button
                  onClick={() => this.handleDialog(true)}
                  color="primary"
                  autoFocus
                >
                  Sí
                </Button>
              </DialogActions>
            )}
          </Dialog>
        )}

        {/* Modal visualizar impresion */}
        <Dialog
          onClose={this.viewPdfClose}
          open={viewPdf || false}
          fullWidth={true}
          maxWidth={"md"}
        >
          <DialogTitle onClose={this.viewPdfClose}>Vista Previa</DialogTitle>
          <DialogContent dividers>
            {pdfURL !== "" && (
              <div className="pdf-viewer">
                <Pdf pdfUrl={pdfURL} />
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.viewPdfClose}>Cancelar</Button>
            <Button variant="contained" onClick={this.handledownloadPdf}>
              Descargar PDF
            </Button>
            <Button variant="contained" onClick={this.handledownloaZip}>
              Descargar XML
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          resumeHideDuration={2000}
          autoHideDuration={2000}
          open={sbOpen === undefined ? false : sbOpen}
          onClose={() => {
            this.setState({ sbOpen: false });
          }}
          TransitionComponent={Slide}
          message={<span>{sbMsg}</span>}
        />
      </div>
    );
  }
}

export default withRouter(Preguias);
